import script from "./DataInconsistencyLastUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistencyLastUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistencyLastUpdate.vue?vue&type=style&index=0&id=b003e4f4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b003e4f4"]])

export default __exports__